module.exports = __webpack_public_path__ + "static/media/Marcello_Cotrim_Curando_Magoas.1779624f.jpg";